import { ViewType } from "../../../../../enums";
import { NoResults, ListViewBase, ListViewWithInMemorySorting } from "../../../../../components";
import ContactRow from "../../../EditAccount/EditContacts/AccountContactsList/ContactRow";
import columnOptions from "../../../EditAccount/EditContacts/AccountContactsList/columnOptions";
import type NewContact from "../../../../../interfaces/NewContact";

import "./ContactList.scss";

export interface ContactListProps {
  contacts: NewContact[];
  onMainContactSet: (contactId: number) => void;
  onContactRemoved: (contactId: number) => void;
}

const mapColumnName = (columnName: string) => {
  switch (columnName.toLowerCase()) {
    case columnOptions[3].name.toLowerCase():
      return "title";
    case columnOptions[1].name.toLowerCase():
      return "firstName";
    default:
      return columnName;
  }
};

const ContactList = ({ onContactRemoved, contacts, onMainContactSet }: ContactListProps) => {
  const renderNoResults = () => {
    return (
      <NoResults
        title="No Contacts"
        description={
          <div className="text-muted">
            <i>Use the form above to add contacts for this account</i>
          </div>
        }
        iconClassName="fal fa-user"
      />
    );
  };

  const buildTableBody = (contact: NewContact) => (
    <ContactRow
      contact={contact}
      isReadOnly={false}
      onContactRemoved={onContactRemoved}
      onMainContactChanged={onMainContactSet}
      isMainContact={contact.isMain}
    />
  );

  return (
    <ListViewWithInMemorySorting
      as={ListViewBase}
      viewType={ViewType.LIST}
      columnOptions={columnOptions}
      mapColumnName={mapColumnName}
      items={contacts}
      withFooter={false}
      withSelection={false}
      noResultsContent={renderNoResults()}
      buildTableBody={buildTableBody}
    />
  );
};

export default ContactList;
